import { useState, useRef } from "react";
import emailjs from "@emailjs/browser";
import "./Contact.scss";
import AnimateDiv from "../AnimateDiv/AnimateDiv";

function Contact() {
    const formRef = useRef();
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState(""); // Tracks success/error messaging

    const sendEmail = (e) => {
        e.preventDefault();
        setLoading(true);
        setStatus("");

        // Replace these strings with your actual EmailJS credentials
        const serviceId = "service_cq9jnxn";
        const templateId = "template_ulcee4m";
        const publicKey = "rbrC3vI1M7751v4AK";

        emailjs.sendForm(serviceId, templateId, formRef.current, publicKey)
            .then(() => {
                setStatus("SUCCESS");
                formRef.current.reset(); // Safely clears out the fields
            })
            .catch((error) => {
                console.error("EmailJS Error:", error);
                setStatus("ERROR");
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <div id="contact" className="contact-me">
            <AnimateDiv>
                <div className="contact-me__wrapper d-flex">
                    <div className="title-sticky left">
                        <h4 className="hero__title">CONTACT ME.</h4>
                        <div className="hero__subtitle contact-me__subtitle">
                            Contact me if you want a professional collaboration with me or you are searching for a
                            programmer.
                        </div>
                    </div>

                    {/* 1. Added formRef and onSubmit handler */}
                    <form ref={formRef} onSubmit={sendEmail} className="contact-me__form">
                        <div className="contact-me__row">
                            <label className="contact-me__label" htmlFor="name">Name:</label>
                            {/* 2. Added name="from_name" and required attribute */}
                            <input
                                data-cmp="sender-name"
                                id="name"
                                name="from_name"
                                className="contact-me__input"
                                type="text"
                                required
                            />
                        </div>

                        <div className="contact-me__row">
                            <label className="contact-me__label" htmlFor="email">Email:</label>
                            {/* 3. Added name="reply_to" and required attribute */}
                            <input
                                data-cmp="sender-email"
                                id="email"
                                name="reply_to"
                                className="contact-me__input"
                                type="email"
                                required
                            />
                        </div>

                        <div className="contact-me__row">
                            <label className="contact-me__label" htmlFor="message">Message:</label>
                            {/* 4. Added required attribute (name="message" was already there!) */}
                            <textarea
                                data-cmp="sender-text"
                                className="contact-me__input"
                                name="message"
                                id="message"
                                cols="30"
                                rows="8"
                                required
                            ></textarea>
                        </div>

                        <div className="contact-me__row">
                            {/* 5. Changed to type="submit" and added basic disabled/loading feedback */}
                            <button
                                data-cmp="send-email"
                                type="submit"
                                className="contact-me__button mb-5"
                                disabled={loading}
                            >
                                {loading ? "SENDING..." : "SEND"}
                            </button>
                        </div>

                        {/* Optional status messages — style these in your SCSS as needed */}
                        {status === "SUCCESS" && (
                            <p className="contact-me__status contact-me__status--success">
                                Message sent successfully! I will get back to you soon.
                            </p>
                        )}
                        {status === "ERROR" && (
                            <p className="contact-me__status contact-me__status--error">
                                Something went wrong. Please try again or reach out directly.
                            </p>
                        )}
                    </form>
                </div>
            </AnimateDiv>
        </div>
    );
}

export default Contact;